import ModulesStore from "./ModuleList/ModulesStore";
import ModuleDetailStore from "./ModuleDetail/ModuleDetailStore";

/**
 * View stores for the Modules area, registered onto the RootStore by
 * `src/appStoresConfig.ts` (wired by the integrator).
 *
 * The names here are the literal prop names components inject — `injectStores`
 * resolves props by stringifying the component and regex-matching `/\w*Store\b/g`,
 * so `modulesStore` and `moduleDetailStore` must match character for character.
 */
const modulesStoreList = [
  { name: "modulesStore", store: ModulesStore },
  { name: "moduleDetailStore", store: ModuleDetailStore },
];

export default modulesStoreList;
